import * as React from 'react'
const PositiveChartIcon = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={69} height={29} fill="none" {...props}>
        <g filter="url(#a)">
            <path
                stroke="#6F83E9"
                strokeWidth={3}
                d="M3.167 21.265s.567-.023.724-.082c.156-.06.929-.214 2.015-1.412 1.086-1.197 2.398-2.007 5.295-.869 2.896 1.139 3.475 1.613 5.406-1.707 1.931-3.32 3.202-2.735 6.324-2.04 3.122.696 2.96-.047 4.73-3.557 1.77-3.51 1.803-4.347 3.67-4.031 1.866.316 2.333.822 4.778 1.043 2.446.222 3.653 6.473 6.807 3.558 3.154-2.916 2.045-2.94 4.345-3.32 2.3-.382 3.275-6.14 6.178-4.174 2.904 1.966 2.592 6.062 6.586 3.238.083-.12 2.319-1.892 3.142-1.66"
            />
        </g>
        <defs>
            <filter id="a" width={68.47} height={27.999} x={0.103} y={0.765} colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse">
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                <feOffset dx={1} dy={2} />
                <feGaussianBlur stdDeviation={2} />
                <feColorMatrix values="0 0 0 0 0.392157 0 0 0 0 0.392157 0 0 0 0 0.392157 0 0 0 0.498039 0" />
                <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_361_10529" />
                <feBlend in="SourceGraphic" in2="effect1_dropShadow_361_10529" result="shape" />
            </filter>
        </defs>
    </svg>
)
export default PositiveChartIcon
